import createAsyncSlice from "../utils/createAsyncSlice";

const vehicles = createAsyncSlice({
  name: "vehicles",
  initialState: {
    data: [],
  },
});

export const fetchVehicles = vehicles.asyncAction;
export const { resetState: resetVehiclesState } = vehicles.actions;
export default vehicles.reducer;
